import img15a from '../../../assets/gallery/15c/15c-01-HOME_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img15b from '../../../assets/gallery/15c/15c-02_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img15c from '../../../assets/gallery/15c/15c-03_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img15d from '../../../assets/gallery/15c/15c-04_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img15e from '../../../assets/gallery/15c/15c-05_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img15f from '../../../assets/gallery/15c/15c-06_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15a,
    description: "2015",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15b,
    description: "2015",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15c,
    description: "2015",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15d,
    description: "2015",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15e,
    description: "2015",
    orientation: "v"
  },
  {
    id: 6,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15f,
    description: "2015",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/15c/data15c.js